import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { postSession } from '../lib/adminApi';
import { useAuth } from '../context/AuthContext';

// Handles the #session_id=... redirect coming back from Emergent Google Auth.
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate('/admin/login');
        return;
      }
      try {
        const data = await postSession(sessionId);
        setUser(data);
        // Clear the hash so it isn't reprocessed
        window.history.replaceState(null, '', window.location.pathname);
        if (data.is_admin) navigate('/admin');
        else navigate('/admin/login?denied=1');
      } catch (e) {
        navigate('/admin/login?error=1');
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0b2027] flex flex-col items-center justify-center text-white">
      <div className="h-12 w-12 rounded-full border-2 border-[#c9a24b] border-t-transparent animate-spin mb-6" />
      <p className="font-serif-display text-xl">Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
